export const GET_CHILD_BACS_DETAIL = 'CHILD_BACS_DETAILS/GET_CHILD_BACS_DETAIL'
export const GET_CHILD_BACS_DETAIL_SUCCESS = 'CHILD_BACS_DETAILS/GET_CHILD_BACS_DETAIL_SUCCESS'
export const GET_CHILD_BACS_DETAIL_FAILED = 'CHILD_BACS_DETAILS/GET_CHILD_BACS_DETAIL_FAILED'

export const CREATE_CHILD_BACS_DETAIL = 'CHILD_BACS_DETAILS/CREATE_CHILD_BACS_DETAIL'
export const CREATE_CHILD_BACS_DETAIL_SUCCESS = 'CHILD_BACS_DETAILS/CREATE_CHILD_BACS_DETAIL_SUCCESS'
export const CREATE_CHILD_BACS_DETAIL_FAILED = 'CHILD_BACS_DETAILS/CREATE_CHILD_BACS_DETAIL_FAILED'

export const CLEAR_CHILD_BACS_DETAIL = 'CHILD_BACS_DETAILS/CLEAR_CHILD_BACS_DETAIL'
